// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import Alpine from "alpinejs";

Alpine.directive("card-parcours", (element, {}, { cleanup }) => {
  const dom = {
    expandBtn: ensureHTMLElement(element.querySelector(".c-cards-parcours__card-expand-btn")),
  };

  function toggleContent(e: Event) {
    const isExpand = element.classList.contains("c-cards-parcours__card--expanded");
    const icon = dom.expandBtn.querySelector(".c-icon");
    if (isExpand) {
      element.classList.remove("c-cards-parcours__card--expanded");
      icon?.classList.add("c-icon--add");
      icon?.classList.remove("c-icon--supp");
    } else {
      element.classList.add("c-cards-parcours__card--expanded");
      icon?.classList.remove("c-icon--add");
      icon?.classList.add("c-icon--supp");
    }
  }

  dom.expandBtn.addEventListener("click", toggleContent);

  cleanup(() => {
    dom.expandBtn.removeEventListener("click", toggleContent);
  });
});
